import * as React from "react";
import { css } from "@emotion/core";
import { Drawer } from "@blueprintjs/core";
import SheetTabs from "./SheetTabs";
import { useNavigate, useParams } from "react-router-dom";

const fetchExportData = (survey_id: number) =>
  fetch(`/api/v1/surveys/${survey_id}/export`).then((response) =>
    response.json()
  );

export default () => {
  const navigate = useNavigate();
  const params = useParams();
  const [data, setData] = React.useState([]);

  React.useEffect(() => {
    const id = Number(params.id);

    fetchExportData(id).then((data) => {
      setData(data.data);
    });
  }, [params.id]);

  return (
    <>
      <Drawer
        icon="th"
        isOpen
        size="90%"
        position="bottom"
        className="bp6-dark"
        title="Spreadsheet Preview"
        onClose={() => navigate("..")}
      >
        <div
          css={css`
            height: 100%;
            display: flex;
            flex-direction: column;
            overflow: hidden;
          `}
        >
          <SheetTabs data={data} />
        </div>
      </Drawer>
    </>
  );
};
